export default __webpack_public_path__ + "static/media/tuna.e9e59f07.png";